module.exports = __webpack_public_path__ + "img/finland-northern-lights.68686bf5.jpg";